var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-bg",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"dots"}),_c('div',{ref:"trail",staticClass:"trail"}),_c('div',{staticClass:"dots-hot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }